module.exports = __webpack_public_path__ + "img/banner-icon-4.140eea8c.webp";